import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import CategoryGrid from './components/CategoryGrid';
import FeaturedVideos from './components/FeaturedVideos';
import LatestVideos from './components/LatestVideos';
import LatestArticles from './components/LatestArticles';
import FAQSection from './components/FAQSection';
import CTASection from './components/CTASection';

export default function Home() {
  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'WebPage',
            name: '91免费 - 高清影视在线平台',
            description: '91免费高清影视在线平台，免费电影在线观看，高清视频免费看。',
            url: 'https://91free.com',
            isPartOf: {
              '@type': 'WebSite',
              name: '91免费',
              url: 'https://91free.com',
            },
            breadcrumb: {
              '@type': 'BreadcrumbList',
              itemListElement: [
                {
                  '@type': 'ListItem',
                  position: 1,
                  name: '首页',
                  item: 'https://91free.com',
                },
              ],
            },
          }),
        }}
      />
      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main>
          <HeroSection />
          <CategoryGrid />
          <FeaturedVideos />
          <LatestVideos />
          <LatestArticles />
          <FAQSection />
          <CTASection />
        </main>
        <Footer />
      </div>
    </>
  );
}